import { GridCellProps } from '@progress/kendo-react-grid';
import { isNumber } from 'lodash';
import { FC, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const PoPercentage: FC<GridCellProps> = (props) => {
  const { dataItem } = props;

  const value = useMemo(
    () =>
      !isNumber(Number(dataItem.poQty)) ||
      !isNumber(Number(dataItem.quantityReceived)) ||
      !isNumber(Number(dataItem.previousQtys)) ||
      Number(dataItem.poQty) === 0
        ? 'N/A'
        : `${Number(Math.round(dataItem?.previousQtys))}%`,
    [dataItem.poQty, dataItem?.previousQtys, dataItem.quantityReceived]
  );

  return (
    <GridCellBase {...props} title={value === 'NaN%' ? '0%' : value}>
      {value === 'NaN%' ? '0%' : value}
    </GridCellBase>
  );
};

export default PoPercentage;
